import { inject, Injectable, Injector } from '@angular/core';
import type { ClientEnvironmentConfig } from '@core/config-models';

import type { JourneyAnalytics } from './models';

@Injectable({ providedIn: 'root' })
export class JourneyAnalyticsLoader {
  #implementation: JourneyAnalytics | null = null;
  readonly #injector = inject(Injector);

  /**
   * Loads an implementation of the JourneyAnalytics interface.
   *
   * This method does a dynamic import of either rudderstack or a stub of the service,
   * to provide developer feedback whilst running locally.
   * @param config Client configuration.
   */
  async load(config: ClientEnvironmentConfig) {
    if (config.journeyAnalytics.enabled) {
      const { RudderstackService } = await import('./rudderstack.service');
      this.#implementation = this.#injector.get(RudderstackService);
    } else {
      const { JourneyAnalyticsStub } = await import('./journey-analytics.stub');
      this.#implementation = this.#injector.get(JourneyAnalyticsStub);
    }

    this.#implementation.init();
  }

  /**
   * Reference to the analytics implementation that is loaded.
   * Either Rudderstack or a stub.
   */
  analyticsInstance() {
    return this.#implementation;
  }
}
